import { render, staticRenderFns } from "./msg-list.vue?vue&type=template&id=c36fe862&scoped=true&"
import script from "./msg-list.vue?vue&type=script&lang=js&"
export * from "./msg-list.vue?vue&type=script&lang=js&"
import style0 from "./msg-list.vue?vue&type=style&index=0&id=c36fe862&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36fe862",
  null
  
)

export default component.exports